// extracted by mini-css-extract-plugin
module.exports = {"item":"AutoSwiper_item__sr4hg","item-text":"AutoSwiper_item-text__BlEEg"};